module.exports = __webpack_public_path__ + "files/19ad057a662ff78318343a96e8ab3ce9.svg";